<div class="row mt-4">
	<div class="col-12">
		<h1 class="centrar_contenido">Mantenedor calendarización <br> de procesos</h1>
	</div>
	<div class="col-12 alert alert-success  tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="mensajeExito !== ''">
    <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{mensajeExito}}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-success">&times;</span>
    </button>
  </div>

	<div class="col-12 alert alert-danger  tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="mensajeError !== ''">
    <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{mensajeError}}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-danger">&times;</span>
    </button>
  </div>
</div>

<!-- CRITERIOS DE BUSQUEDA -->
<div class="row mt-5 align-items-center">
	<div class="hr-amarillo mr-3"></div>
	<h6 class="mb-0">Criterios de búsqueda</h6>

	<div class="col-12">
		<div *ngIf="alertaCreacion !== ''" class="alert alert-success tipografía_alertas mt-5 mb-1 col-12" role="alert">
			<i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>
			{{ alertaCreacion }}
		</div>
	</div>
</div>
<form class="form" [formGroup]="parametrosForm">
	<div class="row mt-5 align-items-end">
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Año</label><label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
			<select id="select_anyo" class="form-control select_criterios" formControlName="anyo" [(ngModel)]="filtroAnyo" (ngModelChange)="resetearValidacion();cargarFiltros('anyo')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyo'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let anyo of listaAnyo" [value]="anyo">{{anyo}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback position-absolute">
				<div *ngIf="tieneErrores['anyo']">Campo requerido</div>
			</div>
		</div>
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label><label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
			<select id="select_periodo" class="form-control select_criterios" formControlName="periodo" [(ngModel)]="filtroPeriodo" (ngModelChange)="resetearValidacion();cargarFiltros('periodo')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let periodo of listaPeriodo" [value]="periodo.periodoAcademicoId">{{periodo.periodoDescripcion}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback position-absolute">
				<div *ngIf="tieneErrores['periodo']">Campo requerido</div>
			</div>
		</div>
		<div class="col-1 centrar_iconos_botones">
			<button (click)="buscarCalendarizacion()" class="boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR"><i class="bi bi-search"></i></button>
		</div>
		<div class="col-1 centrar_iconos_botones">
			<button (click)="limpiarFiltros()" class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top" title="ELIMINAR" alt="ELIMINAR"><i class="bi bi-x"></i></button>
		</div>
		<div class="col-3">
			<button class="boton-copiar" data-toggle="modal" data-target="#modalCopiar" title="COPIAR" alt="COPIAR"><i class="bi bi-files"></i> COPIAR</button>
		</div>
	</div>
</form>
<!-- FIN CRITERIO DE BUSQUEDA -->

<div class="row justify-content-end mt-5">
	<button (click)="navToCrearConfiguracion()" class="boton-primario" style="position: absolute; z-index: 1" data-toggle="tooltip" data-placement="top" title="CREAR CONFIGURACIÓN" alt="CREAR CONFIGURACIÓN"><i class="bi bi-plus-lg mr-2"></i>CREAR CONFIGURACIÓN</button>
</div>



<!-- TABLA -->
<div style="margin-top: 8px;">
	<table *ngIf="renderTable" [dtOptions]="dtOptions" datatable class="table table-striped tabla display nowrap" aria-describedby="tabla calendario">
		<thead class="header_tabla">
			<tr>
				<th class="col_ci_proceso">Proceso</th>
				<th class="col_ci_desc">Descripción</th>
				<th>Fecha inicio</th>
				<th>Fecha fin</th>
				<th>Usuario modificación</th>
				<th>Fecha modificación</th>
				<th>Acción</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let calendario of listaCalendarizaciones; index as indexCalendario">
				<td><p class="celda">{{ calendario.codigoProceso }}</p></td>
				<td><p class="celda">{{ calendario.descripcion }}</p></td>
				<td><p class="celda">{{ calendario.fechaInicio }}</p></td>
				<td><p class="celda">{{ calendario.fechaTermino }}</p></td>
				<td><p class="celda">{{ calendario.usuarioModificacion }}</p></td>
				<td><p class="celda">{{ calendario.fechaActualizacion }}</p></td>
				<td class="justify-content-center">
					<app-popover [popoverId]="indexCalendario">
						<ul>
							<li (click)="editar(calendario)" class="list-group-item border-0 py-1" title="Editar" >
								<div class="row align-items-center">
									<div class="col-2 text-center p-0">
										<i class="bi bi-pencil-square boton-accion_popover px-3"></i>
									</div>
									<div class="col-10 p-0 text-left">
										<p class="mb-0 pl-4">Editar</p>
									</div>
								</div>
							</li>
							<li (click)="popupEliminar(calendario)" class="list-group-item border-0 py-1" title="Eliminar" [ngClass]="{ 'popover-item-disabled': calendario.obligatorio }">
								<div class="row align-items-center">
									<div class="col-2 text-center p-0">
										<i class="bi bi-trash boton-accion_popover px-3"></i>
									</div>
									<div class="col-10 p-0 text-left">
										<p class="mb-0 pl-4">Eliminar</p>
									</div>
								</div>
							</li>
						</ul>
					</app-popover>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<!-- MODAL COPIAR -->
<div class="modal fade" id="modalCopiar" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Copia de configuración</h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR" (click)="resetearValidacion()">
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>
      <form>
				<div class="modal-body">
					<div class="row align-items-center my-3 mx-4">
						<div class="hr-amarillo ml-4"></div>
						<p class="mb-0 ml-3">Origen</p>
					</div>
					<div class="row mt-3 mx-4 my-4">
						<div class="col-6">
							<label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
							<select class="form-control select_criterios" [(ngModel)]="filtroAnyoCopiaOrigen" (ngModelChange)="resetearValidacion();cargarFiltros('anyoCopiaOrigen')" name="anyoOrigen" [ngClass]="{ 'is-invalid': submittedCopia && tieneErrores['anyoCopiaOrigen'] }" required>
								<option [value]="0">Seleccionar</option>
								<option [value]="anyo" *ngFor="let anyo of listaAnyo">{{anyo}}</option>
							</select>
							<div *ngIf="submittedCopia && tieneErrores['anyoCopiaOrigen']" class="invalid-feedback">
								<div *ngIf="tieneErrores['anyoCopiaOrigen']">Campo requerido</div>
							</div>
						</div>
						<div class="col-6">
							<label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
							<select class="form-control select_criterios" [(ngModel)]="filtroPeriodoCopiaOrigen" (ngModelChange)="resetearValidacion();cargarFiltros('periodoCopiaOrigen')" name="periodoOrigen" [ngClass]="{ 'is-invalid': submittedCopia && tieneErrores['periodoCopiaOrigen'] }" required>
								<option [value]="0">Seleccionar</option>
								<option [value]="periodo.periodoAcademicoId" *ngFor="let periodo of listaPeriodoOrigen">{{periodo.periodoDescripcion}}</option>
							</select>
							<div *ngIf="submittedCopia && tieneErrores['periodoCopiaOrigen']" class="invalid-feedback">
								<div *ngIf="tieneErrores['periodoCopiaOrigen']">Campo requerido</div>
							</div>
						</div>
					</div>
					<div>
						<div class="row align-items-center my-3 mx-4">
							<div class="hr-amarillo ml-4"></div>
							<p class="mb-0 ml-3">Destino</p>
						</div>
						<div class="row mt-3 my-4 mx-4">
							<div class="col-6">
								<label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
								<select class="form-control select_criterios" [(ngModel)]="filtroAnyoCopiaDestino" (ngModelChange)="resetearValidacion();cargarFiltros('anyoCopiaDestino')" name="anyoDestino" [ngClass]="{ 'is-invalid': submittedCopia && tieneErrores['anyoCopiaDestino'] }" required>
									<option [value]="0">Seleccionar</option>
									<option [value]="anyo" *ngFor="let anyo of listaAnyo">{{anyo}}</option>
								</select>
								<div *ngIf="submittedCopia && tieneErrores['anyoCopiaDestino']" class="invalid-feedback">
									<div *ngIf="tieneErrores['anyoCopiaDestino']">Campo requerido</div>
								</div>
							</div>
							<div class="col-6">
								<label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
								<select class="form-control select_criterios" [(ngModel)]="filtroPeriodoCopiaDestino" (ngModelChange)="resetearValidacion();cargarFiltros('periodoCopiaDestino')" name="periodoDestino" [ngClass]="{ 'is-invalid': submittedCopia && tieneErrores['periodoCopiaDestino'] }" required>
									<option [value]="0">Seleccionar</option>
									<option [value]="periodo.periodoAcademicoId" *ngFor="let periodo of listaPeriodoDestino">{{periodo.periodoDescripcion}}</option>
								</select>
								<div *ngIf="submittedCopia && tieneErrores['periodoCopiaDestino']" class="invalid-feedback">
									<div *ngIf="tieneErrores['periodoCopiaDestino']">Campo requerido</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="alert alert-danger tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="errorCopia">
									<i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{errorCopia}}
									<button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
										<span aria-hidden="true" class="alert-danger">&times;</span>
									</button>
								</div>
							</div>
						</div>
					</div>

					<div class="modal-footer justify-content-center">
						<button hidden id="btn-copiar" type="body" class="boton-primario my-3 justify-content-center" data-toggle="tooltip" data-placement="top" title="COPIAR" alt="COPIAR" data-dismiss="modal">COPIAR</button>
						<button (click)="copiar()" type="button" class="boton-primario my-3 justify-content-center" data-toggle="tooltip" data-placement="top" title="COPIAR" alt="COPIAR">COPIAR</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>

<!-- FIN MODAL COPIAR -->

<!-- MODAL ELIMINAR -->
<button id="modal-eliminar-calendarizacion" class="btn d-none" data-toggle="modal" data-target="#eliminar">CERRAR Eliminar calendarización</button>
<div class="modal fade" id="eliminar" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header align-items-center">
				<h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Eliminar</h1>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
						<div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
				</button>
			</div>
			<div class="modal-body">
				<form>
					<div class="row align-items-center my-3 mx-4">
						<p class="mb-0 ml-3">¿Estás seguro/a que deseas eliminar el mantenedor de calendarización del proceso <b>{{objCalendarizacionEliminar?.codigoProceso}}</b> ?</p>
					</div>
				</form>
			</div>
			<div class="modal-footer justify-content-center">
				<div class="my-4">
					<button
						class="boton_secundario_modal ml-3"
						data-toggle="tooltip"
						data-placement="top"
						title="SI" alt="SI"
						data-dismiss="modal"
						(click)="eliminar()"
					>
						SI
					</button>
					<button
						class="boton-primario ml-3"
						data-toggle="tooltip"
						data-placement="top"
						title="NO"
						alt="NO" data-dismiss="modal"
						id="btn-modal-eliminar-dismiss"
					>
						NO
					</button>
				</div>
			</div>
		</div>
  </div>
</div>
<!-- FIN MODAL ELIMINAR -->